import { TableRow, TableCell, TableBody, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LogoutIcon from '@mui/icons-material/Logout';
import { IsMobile } from 'utils/global';
import { googleTagManager } from 'use/gtm';

interface TableBodyProps {
  key: number;
  documentName?: string;
  documentLink?: string;
  commercialRelation: string;
}

const DocumentTableBody: React.FC<TableBodyProps> = ({
  key,
  documentName,
  documentLink,
  commercialRelation,
}) => {
  const { t } = useTranslation();
  const isMobile: boolean = IsMobile();

  const onClick = () => {
    googleTagManager({
      event: 'Document Open',
      documentName,
      commercialRelation,
    });
  };

  return (
    <TableBody data-testid="documents-table-body" key={`${documentName}-${key}`}>
      <TableRow
        hover
        sx={{
          '& > *': {
            py: 2,
            pl: 3,
          },
        }}
      >
        <TableCell data-testid="documents-table-documentName">{documentName}</TableCell>
        <TableCell data-testid="documents-table-documentLink" align="left">
          <Button
            component="a"
            href={documentLink}
            target="_blank"
            rel="noopener noreferrer"
            variant="text"
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              textTransform: 'none',
              p: 0,
            }}
            onClick={onClick}
            endIcon={<LogoutIcon fontSize="small" sx={{ marginLeft: isMobile ? '5px' : '10px' }} />}
          >
            {t('documents.table.body.goToDocument')}
          </Button>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

export default DocumentTableBody;
